window.onclick_exlink = function (domain, area, spot_id, hotel_code, price, alliance, eventparam) {
  if (/tabelog/.test(domain)) {
    // eslint-disable-next-line no-undef
    onclickcatalyst_tabelog(domain, area);
  } else {
    // eslint-disable-next-line no-undef
    onclickcatalyst_exlink(domain, area, spot_id, hotel_code, price, alliance, eventparam);
  }
  // eslint-disable-next-line no-undef
  ga("send", "event", "外部リンク送客", "click", "#{domain} | #{area}");
  true;
};

window.onclick_share = function (link, area) {
  // eslint-disable-next-line no-undef
  onclickcatalyst_share(link, area);
  // eslint-disable-next-line no-undef
  ga("send", "event", "SNSシェア", "click", "#{link} | #{area}");
  true;
};
